import {
  IKiAttachment,
  KI_ATTACHMENT_MAX_BYTES,
  KI_ATTACHMENT_TYPES,
} from '../Interfaces/IKi';

/**
 * Dateien für die KI-Anbindung (#1336).
 *
 * Zwei Stellen brauchen dasselbe: das Chatfenster und der Import eines
 * Grundbuchauszugs. Geprüft wird hier **und** auf dem Server — hier, damit die
 * Meldung kommt, bevor zehn Megabyte hochgehen; dort, weil eine Prüfung im
 * Browser keine Prüfung ist.
 */

/** Gibt eine Meldung zurück, wenn die Datei nicht taugt — sonst `null`. */
export const validateAttachmentFile = (
  file: File,
  allowedTypes: string[] = KI_ATTACHMENT_TYPES
): string | null => {
  if (!allowedTypes.includes(file.type)) {
    const labels = allowedTypes.includes('application/pdf') && allowedTypes.length === 1
      ? 'PDF'
      : 'PDF, PNG, JPEG und WebP';

    return `„${file.name}" kann nicht gelesen werden. Möglich sind ${labels}.`;
  }

  if (file.size > KI_ATTACHMENT_MAX_BYTES) {
    return (
      `„${file.name}" ist ${(file.size / 1024 / 1024).toFixed(1)} MB groß. ` +
      `Erlaubt sind ${KI_ATTACHMENT_MAX_BYTES / 1024 / 1024} MB.`
    );
  }

  return null;
};

/**
 * Eine Datei in die Form bringen, die die KI-Endpunkte erwarten.
 *
 * `readAsDataURL` liefert `data:<mime>;base64,<daten>` — der Kopf fliegt hier
 * weg, damit über die Leitung nur die Nutzdaten gehen.
 */
export const fileToAttachment = (file: File): Promise<IKiAttachment> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const raw = String(reader.result ?? '');
      resolve({
        FileName: file.name,
        MimeType: file.type,
        Data: raw.includes(',') ? raw.slice(raw.indexOf(',') + 1) : raw,
      });
    };
    reader.onerror = () =>
      reject(new Error('Die Datei konnte nicht gelesen werden.'));
    reader.readAsDataURL(file);
  });
